import { render, staticRenderFns } from "./ConstructionPortlet.vue?vue&type=template&id=7ad9d55a&"
import script from "./ConstructionPortlet.vue?vue&type=script&lang=js&"
export * from "./ConstructionPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports